type SalesType = 'Growth' | 'NewBiz';

export type SalesSource =
  | 'SamplingModal'
  | 'TrendsTrial'
  | 'TrendsBasic'
  | 'TrendsPlus'
  | 'TrendsBusiness'
  | 'FunnelsTrial'
  | 'FunnelsBasic'
  | 'FunnelsPlus'
  | 'FunnelsBusiness'
  | 'TrendsBanner'
  | 'FunnelsBanner'
  | 'RecordingsBanner'
  | 'DashboardBanner'
  | 'MultiProductUpsell'
  | 'InAppModal'
  | 'InAppTile'
  | 'SsoSignup'
  | 'BillingPage';

type SalesTypeToURL = {
  [salesType in SalesType]: string;
};

const SalesSourceURLs: Record<SalesSource, string | SalesTypeToURL> = {
  SamplingModal: 'https://hotjar.chilipiper.com/router/sampling-modal-router',
  TrendsTrial:
    'https://calendly.com/hotjar-sales-team/trends-discovery-chat?utm_medium=Insights&utm_source=Trends&utm_term=Trial',
  TrendsBasic:
    'https://calendly.com/hotjar-sales-team/trends-discovery-chat?utm_medium=Insights&utm_source=Trends&utm_term=BasicPlan',
  TrendsPlus:
    'https://calendly.com/hotjar-growth-team/trends-discovery-call?utm_medium=Insights&utm_source=Trends&utm_term=PlusPlan',
  TrendsBusiness:
    'https://calendly.com/hotjar-growth-team/trends-discovery-call?utm_medium=Insights&utm_source=Trends&utm_term=BusinessPlan',
  FunnelsTrial:
    'https://calendly.com/hotjar-sales-team/funnels-discovery-chat?utm_medium=Insights&utm_source=Funnels&utm_term=Trial',
  FunnelsBasic:
    'https://calendly.com/hotjar-sales-team/funnels-discovery-chat?utm_medium=Insights&utm_source=Funnels&utm_term=BasicPlan',
  FunnelsPlus:
    'https://calendly.com/hotjar-growth-team/funnels-discovery-call?utm_medium=Insights&utm_source=Funnels&utm_term=PlusPlan',
  FunnelsBusiness:
    'https://calendly.com/hotjar-growth-team/funnels-discovery-call?utm_medium=Insights&utm_source=Funnels&utm_term=BusinessPlan',
  RecordingsBanner: {
    Growth:
      'https://calendly.com/hotjar-growth-team?utm_medium=Insights&utm_source=RecordingsBanner',
    NewBiz:
      'https://calendly.com/hotjar-sales-team?utm_medium=Insights&utm_source=RecordingsBanner',
  },
  // TODO: This banner should have a specific sales links
  TrendsBanner: {
    Growth:
      'https://calendly.com/hotjar-growth-team?utm_medium=Insights&utm_source=RecordingsBanner',
    NewBiz:
      'https://calendly.com/hotjar-sales-team?utm_medium=Insights&utm_source=RecordingsBanner',
  },
  // TODO: This banner should have a specific sales links
  FunnelsBanner: {
    Growth:
      'https://calendly.com/hotjar-growth-team?utm_medium=Insights&utm_source=RecordingsBanner',
    NewBiz:
      'https://calendly.com/hotjar-sales-team?utm_medium=Insights&utm_source=RecordingsBanner',
  },
  DashboardBanner: {
    Growth:
      'https://calendly.com/hotjar-growth-team?utm_medium=Insights&utm_source=DashboardBanner',
    NewBiz: 'https://calendly.com/hotjar-sales-team?utm_medium=Insights&utm_source=DashboardBanner',
  },
  MultiProductUpsell: 'https://hotjar.chilipiper.com/router/upsell-modal-router',
  InAppModal: 'https://hotjar.chilipiper.com/router/in-app-modal-router',
  InAppTile: 'https://hotjar.chilipiper.com/router/in-app-tile-router',
  SsoSignup:
    'https://calendly.com/hotjar-sales-discovery/hotjar-discovery-chat?utm_medium=website&utm_source=SignupSSO',
  BillingPage: 'https://hotjar.chilipiper.com/router/billing-cta-router',
};

function isSourceWithSalesTypes(
  salesSource: string | SalesTypeToURL,
): salesSource is SalesTypeToURL {
  return salesSource instanceof Object;
}

/**
 * This functions should be used whenever a component needs sales link.
 * The aim of this function is to create a function where all logic that is needed in the future can be placed in just one place without refactoring anywhere else
 */
export const getSalesLink = (salesSource: SalesSource, salesType?: SalesType): string => {
  const source = SalesSourceURLs[salesSource];
  if (isSourceWithSalesTypes(source)) {
    if (salesType) {
      return source[salesType];
    }

    // default to Growth to avoid any error being thrown and to redirect at least to Sales (even if it's not the correct team)
    return source.Growth;
  }

  return source;
};
